<template>
    <div>
    <header class="header">
            <img v-if="languageIndex == 0" src="/static/img/banner1.png" alt="">
            <img v-else src="/static/img/banner11.png" alt="">
            <navHeader ref=navHeader></navHeader>
    </header>
    <main class="main">
        <nav class="nav">
            <ul>
                <li @click="aboutus()" class="pointer_box">{{langtrans().gywmm[languageIndex]}}</li>
                <li @click="news()" class="pointer_box">{{langtrans().xwzzx[languageIndex]}}</li>
                <li @click="league()" class="pick pointer_box">{{langtrans().qqjylm[languageIndex]}}</li>
                <li @click="stars()" class="pointer_box">{{langtrans().xssffw[languageIndex]}}</li>
            </ul>
        </nav>
        <section class="section">
            <div class="league_box">
                <p>{{langtrans().ffqbbl[languageIndex]}}</p>
            </div>
            <div class="add_box">
                <h3>{{langtrans().bcgggx[languageIndex]}}</h3>
                <ul>
                    <li>
                      <img src="/static/images/1_list.png" alt="">
                      {{langtrans().jrzzgz[languageIndex]}}</li>
                    <li>
                      <img src="/static/images/2_list.png" alt="">
                      {{langtrans().hdddqq[languageIndex]}}</li>
                    <li>
                      <img src="/static/images/3_list.png" alt="">
                      {{langtrans().ytlmmp[languageIndex]}}</li>
                    <li>
                      <img src="/static/images/4_list.png" alt="">
                      {{langtrans().mnjxhh[languageIndex]}}</li>
                </ul>
            </div>                                                                                                                                                                                                       
        </section>    
    </main>
    <p class="p_box">
      <button @click="iscover=true">{{langtrans().ljjrqq[languageIndex]}}</button>
    </p>
    <vFooter @performHeader=performHeader></vFooter>
    <div v-if="iscover" class="cover">
        <div class="modal">
            <h2>{{langtrans().ffwsjm[languageIndex]}}</h2>
            <form>
                <label for="name">
                    <span>
                        <small>公司名称:</small>
                        <small>Company name</small>
                    </span>
                    <input type="text" name="" id="name" :placeholder="langtrans().srgsmc[languageIndex]">
                </label>
                <label for="type">
                    <span>
                        <small>服务类型:</small>
                        <small>Service type</small>
                    </span>
                    <input type="text" name="" id="type" :placeholder="langtrans().srgsff[languageIndex]">
                </label>
                <label for="Country">
                    <span>
                        <small>国家:</small>
                        <small>Country</small>
                    </span>
                    <input type="text" name="" id="Country" :placeholder="langtrans().srgssf[languageIndex]">
                </label>
                <label for="Contact">
                    <span>
                        <small>联系人姓名:</small>
                        <small>Contact name</small>
                    </span>
                    <input type="text" name="" id="Contact" :placeholder="langtrans().srgslx[languageIndex]">
                </label>
                <label for="Tel">
                    <span>
                        <small>电话:</small>
                        <small>Tel</small>
                    </span>
                    <input type="text" name="" id="Tel" :placeholder="langtrans().srlxjr[languageIndex]">
                </label>
                <label for="Email">
                    <span>
                        <small>邮箱:</small>
                        <small>Company name</small>
                    </span>
                    <input type="text" name="" id="Email" :placeholder="langtrans().srgsyx[languageIndex]">
                </label>
                <label for="Message">
                    <span>
                        <small>信息:</small>
                        <small>Message</small>
                    </span>
                    <input type="text" name="" id="Message" :placeholder="langtrans().srgsyx[languageIndex]">
                </label>
            </form>
            <p><button @click="iscover=false;ok()">{{langtrans().tdsjxs[languageIndex]}}</button></p>
        </div>
        <span @click="iscover=false" class="remove pointer_box">
            ×
        </span>
    </div>
    </div>
</template>

<script>
import langtrans from "@/assets/languagejs/league.vue.trans.js";
import { Message } from "element-ui";
import constants from "@/util/constants.js";
import navHeader from '@/components/header/indexHeader'
import vFooter from '@/components/footer/indexFooter'
export default {
  data() {
    return {
      iscover: false,
      flag: true,
      usertype: "",
      user: "",
      pwd: ""
    };
  },
  components:{
  	navHeader,
  	vFooter  	
  },
		computed:{
			languageIndex(){
				return this.$store.state.language
			}
		},	
  methods: {
		langtrans(){
			return langtrans
		},	
    performHeader(str){
    	this.$refs.navHeader.login(str)
    },
    ok() {
      Message.success("您已成功提交信息");
    },
    news() {
      this.$router.push({
        name: "news"
      });
    },
    league() {
      this.$router.push({
        name: "league"
      });
    },
    stars() {
      this.$router.push({
        name: "stars"
      });
    },
    feedback() {
      this.$router.push({
        name: "feedback"
      });
    },
    aboutus() {
      this.$router.push({
        name: "aboutus"
      });
    },
    dowapp() {
      this.$router.push({
        name: "dowapp"
      });
    },
    index() {
      this.$router.push({
        name: "Index"
      });
    },
    contact() {
      this.$router.push({
        name: "contact"
      });
    },
 },

		computed:{
			languageIndex(){
				return this.$store.state.language
			}
		},
  mounted() {
    // let btn = document.querySelector(".btn");
    // let cover = document.querySelector(".cover");
    // let modal = document.querySelector(".modal");
    // let remove = document.querySelector(".remove");
    // btn.onclick = function() {
    //   cover.style.display = "block";
    // };
    // remove.onclick = function() {
    //   cover.style.display = "none";
    // };
  }
};
</script>

<style scoped>
@import url(../../static/css/global.css);
.section > div:first-child {
  margin-top: 0.9vw;
}
.section .league_box p {
  font-size: 1.125vw;
  color: #666;
}
.section .add_box h3 {
  font-size: 1.375vw;
  color: #333;
}
.section .add_box ul {
  margin-top: 0.9375vw;
}
.section .add_box ul li {
  font-size: 1.125vw;
  position: relative;
  line-height: 3vw;
  height: 3vw;
  color: #333;
  display: flex;
  align-items: center;
}
.section .add_box ul li img {
  height: 1.5vw;
  margin-right: 1vw;
  width: 1.5vw;
}
.p_box {
  padding-bottom: 3.15vw;
  background: #fff;
  text-align: center;
}
.p_box button {
  width: 18.75vw;
  height: 3.4375vw;
  border: 0;
  border-radius: 0.375vw;
  background: #00abfa;
  color: #fff;
  font-size: 1.25vw;
}
.cover {
  position: fixed;
  width: 100%;
  height: 100%;
  top: 0;
  z-index: 997;
  background: rgba(0, 0, 0, 0.3);
}
.modal {
  position: absolute;
  top: 50%;
  margin-top: -21.25vw;
  left: 50%;
  margin-left: -28.125vw;
  background: #fff;
  width: 56.25vw;
  height: 42.5vw;
  z-index: 998;
  border-radius: 0.3125vw;
  border: 0.0625vw solid #d9ddde;
}
.remove {
  position: fixed;
  top: 2vw;
  right: 17vw;
  width: 2.5vw;
  height: 2.5vw;
  font-size: 1.875vw;
  color: #ccc;
  text-align: center;
  line-height: 2.5vw;
  border-radius: 50%;
  background: rgba(0, 0, 0, 0.7);
}
.modal h2 {
  width: 100%;
  text-align: center;
  margin-top: 0.625vw;
  line-height: 3.125vw;
  font-size: 1.25vw;
  color: #333;
}
.modal form {
  width: 100%;
  padding: 1vw 5vw 2vw;
  box-sizing: border-box;
}
.modal form label {
  display: block;
  width: 100%;
  height: 2.8125vw;
  margin-top: 1.875vw;
}
.modal form label:first-child {
  margin-top: 0;
}
.modal form label span {
  float: left;
  width: 11.25vw;
}
.modal form label span small {
  display: inline-block;
  width: 100%;
}
.modal form label span small:first-child {
  font-size: 1vw;
  color: #303030;
}
.modal form label span small:last-child {
  font-size: 0.875vw;
  color: #777;
}
.modal form label input {
  float: left;
  height: 2.8125vw;
  width: 28.125vw;
  border: 0;
  border-radius: 0.3125vw;
  border: 0.0625vw solid #ccc;
  padding-left: 0.9vw;
}
.modal > p {
  width: 100%;
  text-align: center;
}
.modal > p button {
  width: 17.5vw;
  height: 3.125vw;
  border: 0;
  border-radius: 0.25vw;
  background: #00abfa;
  font-size: 1.3125vw;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/league.vue